const links = [
  {
    label: 'Github',
    url: 'https://github.com/Gianluska',
  },
  {
    label: 'Linkedin',
    url: 'https://www.linkedin.com/in/gianlucca-claudino/',
  },
  // {
  //   label: 'Youtube',
  //   url: 'https://www.youtube.com/channel/UCPA4JfjAxqAD68RP0OV_wWw',
  // },
  {
    label: 'Instagram',
    url: 'https://www.instagram.com/gianluska_',
  },
  {
    label: 'Dribbble',
    url: 'https://dribbble.com/Gianluska',
  },
]

export default links